import React from "react";
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  TextField,
} from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
const CourseSearchForm = ({
  setVenueId,
  fromDate,
  venueId,
  setFromDate,
  toDate,
  setToDate,
  handleSearch,
  handleReset,
  handleReusableAds,
  active,
  processed,
  setActive,
  setProcessed,
  setIcpisManager,
  icpisManager,
  icpisManagers = [],
  adAddress,
  setAdAddress,
  courseStatus,
  setCourseStatus,
  userRole,
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box
        component="form"
        onSubmit={(e) => {
          e.preventDefault();
          handleSearch(1);
        }}
        display="flex"
        alignItems="center"
        flexWrap="wrap"
        gap={1.5}
        mb={3}
      >
        {userRole === "ROLE_ICPIE" && (
          <FormControl
            variant="outlined"
            size="small"
            sx={{ minWidth: 220, flex: "1 1 220px" }}
          >
            <InputLabel id="icpis-manager-label">ICPIS Manager</InputLabel>
            <Select
              value={icpisManager}
              onChange={(e) => setIcpisManager(e.target.value)}
              labelId="icpis-manager-label"
              label="ICPIS Manager"
            >
              <MenuItem value="">
                <em>Please Select</em>
              </MenuItem>
              {icpisManagers.map((manager) => (
                <MenuItem key={manager} value={manager}>
                  {manager}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        <TextField
          variant="outlined"
          size="small"
          label="Venue ID"
          value={venueId}
          onChange={(e) => setVenueId(e.target.value)}
          sx={{ minWidth: 120, flex: "1 1 140px" }}
        />

        <TextField
          variant="outlined"
          size="small"
          label="AD Address"
          value={adAddress}
          onChange={(e) => setAdAddress(e.target.value)}
          placeholder="Search by address (e.g., San Jose)"
          sx={{ minWidth: 220, flex: "2 1 260px" }}
        />

        <FormControl
          variant="outlined"
          size="small"
          sx={{ minWidth: 160, flex: "1 1 160px" }}
        >
          <InputLabel id="is-published-label">Is Published</InputLabel>
          <Select
            value={active ?? ""}
            onChange={(e) => setActive(e.target.value)}
            labelId="is-published-label"
            label="Is Published"
          >
            <MenuItem value="">
              <em>Please Select</em>
            </MenuItem>
            <MenuItem value="true">true</MenuItem>
            <MenuItem value="false">false</MenuItem>
          </Select>
        </FormControl>

        <FormControl
          variant="outlined"
          size="small"
          sx={{ minWidth: 160, flex: "1 1 160px" }}
        >
          <InputLabel id="is-processed-label">Is Processed</InputLabel>
          <Select
            value={processed ?? ""}
            onChange={(e) => setProcessed(e.target.value)}
            labelId="is-processed-label"
            label="Is Processed"
          >
            <MenuItem value="">
              <em>Please Select</em>
            </MenuItem>
            <MenuItem value="true">true</MenuItem>
            <MenuItem value="false">false</MenuItem>
          </Select>
        </FormControl>

        <FormControl
          variant="outlined"
          size="small"
          sx={{ minWidth: 200, flex: "1 1 220px" }}
        >
          <InputLabel id="course-status-label">Course Status</InputLabel>
          <Select
            value={courseStatus}
            onChange={(e) => setCourseStatus(e.target.value)}
            labelId="course-status-label"
            label="Course Status"
          >
            <MenuItem value="">
              <em>All</em>
            </MenuItem>
            <MenuItem value="0">Normal</MenuItem>
            <MenuItem value="1">Cancelled (Reusable)</MenuItem>
            <MenuItem value="2">Already Reused</MenuItem>
            <MenuItem value="3">Repost Required</MenuItem>
          </Select>
        </FormControl>

        {/* DateTimePicker for 'from' and 'to' time range */}
        <DatePicker
          label="From"
          value={fromDate ? dayjs(fromDate) : null}
          onChange={(newValue) => {
            const formattedDate = dayjs(newValue).format("YYYY-MM-DD"); // 使用 dayjs 格式化日期
            console.log("Formatted From Date:", formattedDate);
            setFromDate(formattedDate);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              sx={{ minWidth: 160, flex: "1 1 180px" }}
            />
          )}
        />

        <DatePicker
          label="To"
          value={toDate ? dayjs(toDate) : null}
          onChange={(newValue) => {
            const tomattedDate = dayjs(newValue).format("YYYY-MM-DD"); // 使用 dayjs 格式化日期
            console.log("Formatted From Date:", tomattedDate);
            setToDate(tomattedDate);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              sx={{ minWidth: 160, flex: "1 1 180px" }}
            />
          )}
        />

        <Box
          display="flex"
          alignItems="stretch"
          gap={1}
          sx={{ flex: "0 0 auto" }}
        >
          <Box display="flex" flexDirection="column" gap={1}>
            <Button type="submit" variant="contained" color="primary">
              Search
            </Button>
            <Button
              type="button"
              variant="contained"
              color="primary"
              onClick={handleReusableAds}
            >
              Reusable Ads
            </Button>
          </Box>
          <Button
            type="button"
            variant="outlined"
            onClick={handleReset}
            sx={{
              px: 2.5,
              alignSelf: "stretch",
              height: "auto",
              minWidth: 96,
            }}
          >
            Reset
          </Button>
        </Box>
      </Box>
    </LocalizationProvider>
  );
};

export default CourseSearchForm;
